import React from 'react';
const Posts:React.FC = ()=>{
    return (
        <>
        <h1>Notification</h1>
        <p>Coming soon</p>
        </>
    )
};
export default Posts;